import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@/components/ui/theme-provider";
import App from "./components/App.tsx";
import Login from "./components/Login.tsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ApiConfigProvider } from "./utils/ApiConfigContext.tsx";
import { AuthProvider } from "./utils/AuthContext.tsx";
import PrivateRoute from "./utils/PrivateRoute.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID}>
      <AuthProvider>
        <ApiConfigProvider>
          <BrowserRouter>
            <Routes>
              <Route path="login/:accountParam?" element={<Login />} />
              <Route
                path="*"
                element={
                  <PrivateRoute>
                    <App />
                  </PrivateRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </ApiConfigProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </ThemeProvider>
);
